import moment from 'moment';

export const getDaysAndRange = (value: string): [number, number, string] => {
  let start: number = 0;
  let end: number = 0;
  let days: string = '30';
  switch (value) {
    case 'lastWeek':
      start = moment().subtract(1, 'weeks').unix();
      end = moment().unix();
      days = '7';
      break;
    case 'lastMonth':
      start = moment().subtract(1, 'months').unix();
      end = moment().unix();
      days = '30';
      break;
    case 'last3Months':
      start = moment().subtract(3, 'months').unix();
      end = moment().unix();
      days = '90';
      break;
    case 'lastYear':
      start = moment().subtract(1, 'years').unix();
      end = moment().unix();
      days = '365';
      break;
    case 'allTime':
      days = '365';
  }

  return [start, end, days];
};
